export default function FormanDashboard() {
  return <div className="text-white">Foreman Dashboard - Coming Soon!</div>;
}
